import { Patro } from "@/components/types/Patro";

export const patrocinios: Patro[] = [
    {
        index: 0,
        url: '/assets/patrocinio1.png'
    },
    {
        index: 1,
        url: '/assets/patrocinio2.png'
    },
    {
        index: 2,
        url: '/assets/patrocinio3.png'
    },
    {
        index: 3,
        url: '/assets/patrocinio4.png'
    }
];